import React, { Fragment, useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { Button, Col, Row } from "reactstrap";
import AppContext from "../../context/Context";
import APICall from "../../services/apiCall";
import APIPortalTable from "../common/Table/APIPortalTable";

const DemoPracticesModal = ({ devid, setDemoPracticesModal, applicationDetails, setUpdateDataFlag }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedPractice, setSelectedPractice] = useState("");
  const [rowSelection, setRowSelection] = useState({});

  const { loginUserDetails } = useContext(AppContext);

  useEffect(() => {
    setLoading(true);
    let params={
      devid:loginUserDetails.dev_id
    }
    APICall.servertrip("GET", "demo_practice_list", loginUserDetails,params).then(
      (res) => {
        setData(res.data.items);
        setLoading(false);
      },
      (error) => {
        const resMessage =
          (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
        toast.error(resMessage);
        setLoading(false);
      }
    );
  }, []);

  const CustomTotal = ({ sizePerPage, totalSize, page, lastIndex }) => (
    <span>
      {(page - 1) * sizePerPage + 1} to {lastIndex > totalSize ? totalSize : lastIndex} of {totalSize}
    </span>
  );

  const options = {
    custom: true,
    sizePerPage: 6,
    totalSize: data?.length,
  };

  const handleNextPage = ({ page, onPageChange }) => () => {
    onPageChange(page + 1);
  };

  const handlePrevPage = ({ page, onPageChange }) => () => {
    onPageChange(page - 1);
  };

  const columns = [
    {
      dataField: "master_customer_id",
      text: "Master Customer ID",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
    },
    {
      dataField: "pms",
      text: "PMS",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
    },
    {
      dataField: "domain",
      text: "Domain",
      classes: "border-0 align-middle",
      headerClasses: "border-0",
      sort: true,
    },
  ];

  let materialColumns = [
    {
      accessorKey: "master_customer_id", //simple recommended way to define a column
      header: "Master Customer ID",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: true,
      // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
      Cell: ({ cell, row, renderedCellValue }) => <span>{renderedCellValue}</span>, //optional custom cell render
    },
    {
      accessorKey: "pms", //simple recommended way to define a column
      header: "PMS",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: true,
      // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
      Cell: ({ cell, row, renderedCellValue }) => <span>{renderedCellValue}</span>, //optional custom cell render
    },
    {
      accessorKey: "domain", //simple recommended way to define a column
      header: "Domain",
      csvFormatter: (cell, row, rowIndex) => {
        if (cell === "") {
          return "--";
        } else {
          return cell;
        }
      },
      sort: true,
      csvExport: true,
      enableResizing: true,
      // muiTableHeadCellProps: { sx: { color: "green" } }, //optional custom props
      Cell: ({ cell, row, renderedCellValue }) => <span>{renderedCellValue}</span>, //optional custom cell render
    },
  ];

  const handleAddingDemoPractices = () => {
    if (selectedPractice) {
      let body = {
        app_id: applicationDetails.app_id,
        master_customer_id: selectedPractice.master_customer_id,
        parent_master_customer_id: applicationDetails.parent_master_customer_id,
        user_name: selectedPractice.email_id, //Email id
        opt_flag: "1", // If ON then 1 else 0
        app_name: applicationDetails.app_name,
        dev_id: devid,
        partner_name: applicationDetails.partner_name,
        add_updated_by: loginUserDetails.user_name,
        old_flag: "1", // If ON then 1 else 0. here you need to pass 1
        is_add_updated_by_admin: loginUserDetails.is_partner === "0" ? "true" : "false",
      };
      APICall.servertrip("POST", "auth_practice_details", loginUserDetails, undefined, body).then(
        (res) => {
          setLoading(false);
          toast.success("Demo practice added successfully");
          setUpdateDataFlag(true);
          setDemoPracticesModal(false);
        },
        (error) => {
          const resMessage =
            (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
          toast.error(resMessage);
          setLoading(false);
        }
      );
    } else {
      toast.warning("Please select a customer to continue");
    }
  };

  useEffect(() => {
    //do something when the row selection changes...
    if (Object.keys(rowSelection).length > 0) {
      let selectedDemoPractice = data.find((prac) => prac.master_customer_id === Object.keys(rowSelection)[0]);
      setSelectedPractice(selectedDemoPractice);
    }
  }, [rowSelection]);

  return (
    <div>
      <APIPortalTable
        data={data}
        columns={materialColumns}
        loading={loading}
        enablePagination
        enableRowSelection
        enableMultiRowSelection={false}
        onRowSelectionChange={setRowSelection}
        getRowId={(originalRow) => originalRow.master_customer_id}
        state={{ rowSelection }}
        CSVFileName={"Demo Practices List"}
      />
      <Row className="modal-footer bg-light m-1" style={{ marginBottom: "-16px" }}>
        <Button className="ml-auto" size="sm" color="success" type="submit" onClick={() => handleAddingDemoPractices()}>
          Save
        </Button>
        <Button
          size="sm"
          color="danger"
          onClick={() => {
            setDemoPracticesModal(false);
          }}
        >
          Cancel
        </Button>
      </Row>
    </div>
  );
};
export default DemoPracticesModal;
